import React from "react";

/* ── Image imports ── */
import HeroBgImg    from "../../../asset/images/careers/hero-bg.webp";
import BcSepIcon    from "../../../asset/images/about/breadcrumb-separator.svg";
import SlideImg1    from "../../../asset/images/careers/slide-1.webp";
import SlideImg2    from "../../../asset/images/careers/slide-2.webp";
import SlideImg3    from "../../../asset/images/careers/slide-3.webp";
import SlideImg4    from "../../../asset/images/careers/slide-4.webp";
import CtaBgImg     from "../../../asset/images/careers/cta-bg.webp";

/* ── Social icon image imports ── */
import IconReadImg   from "../../../asset/images/careers/icon-read.svg";
import IconChartImg  from "../../../asset/images/careers/icon-chart.svg";
import IconSportsImg from "../../../asset/images/careers/icon-sports.svg";
import IconSmileImg  from "../../../asset/images/careers/icon-smile.svg";

const SLIDES = [SlideImg1, SlideImg2, SlideImg3 , SlideImg4];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ca { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* TOP RED BAR */
  .ca-top-bar { width: 100%; height: 0px;  }

  /* 1. HERO */
  .ca-hero { position: relative; width: 100%; height: 460px; overflow: hidden; }
  .ca-hero-bg { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center top; display: block; }
  .ca-hero-overlay { position: absolute; inset: 0; }
  .ca-hero-content { position: absolute; inset: 0; display: flex; flex-direction: column; justify-content: center; padding: 0 102px; max-width: 1600px; margin: 0 auto; left: 0; right: 0; }
  .ca-hero-title { font-family: 'Poppins', sans-serif; font-size: 42px; font-weight: 600; color: #ffffff; line-height: 120%; margin-bottom: 15px; }
  .ca-hero-divider { width: 559px; height: 2px; background: #EB2019; border: none; margin-bottom: 15px; }
  .ca-hero-desc { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 400; color: #ffffff; line-height: 160%; max-width: 501px; }

  /* 2. BREADCRUMB */
  .ca-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ca-breadcrumb-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; display: flex; align-items: center; flex-wrap: wrap; }
  .ca-bc-item { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 500; color: #202020; text-decoration: none; display: flex; align-items: center; transition: color 0.15s; }
  .ca-bc-item:hover { color: #EB2019; }
  .ca-bc-sep { display: flex; align-items: center; justify-content: center; width: 24px; height: 24px; border-radius: 50%; margin: 0 8px; flex-shrink: 0; }
  .ca-bc-item.active { color: #202020; font-weight: 500; }

  /* SHARED INNER */
  .ca-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* 3. MAIN CONTENT */
  .ca-main-section { padding: 120px 0 120px 0; }
  .ca-main-row { display: flex; align-items: flex-start; gap: 154px; }

  .ca-left { flex: 0 0 559px; min-width: 0; padding-top:14px; }
  .ca-heading { font-family: 'Poppins', sans-serif; font-size: 38px; font-weight: 600; color: #202020; line-height: 140%; margin-bottom: 15px; }
  .ca-quote { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 400; color: #202020; line-height: 160%; margin-bottom: 15px; }
  .ca-body { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 400; color: #202020; line-height: 160%; margin-bottom: 30px; }

  .ca-social-row { display: flex; align-items: center; gap: 44px; background:#F5F5F5; max-width:356px; padding:24px;border-radius:10px; }
  .ca-social-icon { width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .ca-social-icon svg { width: 48px; height: 48px; gap:44px; }

  .ca-right { flex: 0 0 683px; display: flex; flex-direction: column; }
  .ca-slider { position: relative; width: 100%; height: 528px; border-radius: 10px; overflow: hidden; background: #ddd; user-select: none; }
  .ca-slider.dragging { }
  .ca-slide { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center; display: block; opacity: 0; transition: opacity 0.5s ease; }
  .ca-slide.active { opacity: 1; }

  .ca-ador-badge { position: absolute; bottom: 16px; left: 16px; background: #ffffff; border-radius: 6px; padding: 8px 14px 8px 10px; display: none; align-items: center; gap: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.15); z-index: 2; }
  .ca-ador-badge-name { font-family: 'Poppins', sans-serif; font-size: 13px; font-weight: 700; color: #202020; line-height: 1; letter-spacing: 0.03em; }
  .ca-ador-badge-sub { font-family: 'Poppins', sans-serif; font-size: 10px; font-weight: 400; color: #888888; line-height: 1.3; margin-top: 2px; }

  .ca-dots { display: flex; align-items: center; justify-content: center; gap: 6px; margin-top: 14px; }
  .ca-dot { height: 7px; border-radius: 4px; background: #cccccc; cursor: pointer; transition: background 0.25s, width 0.25s; width: 7px; border: none; padding: 0; }
  .ca-dot.active { background: #EB2019; width: 20px; }

  /* 4. CTA */
  .ca-cta-section { position: relative; width: 100%; min-height: 450px; overflow: hidden; display: flex; align-items: center; }
  .ca-cta-bg { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center center; display: block; }
  .ca-cta-inner { position: relative; z-index: 2; max-width: 1600px; margin: 0 auto; padding: 0 102px; width: 100%; }
  .ca-cta-title { font-family: 'Poppins', sans-serif; font-size: 32px; font-weight: 600; color: #ffffff; line-height: 120%; margin-bottom: 15px; }
  .ca-cta-subtitle { font-family: 'Poppins', sans-serif; font-size: 20px; font-weight: 400; color: #FFFFFF; line-height: 160%; margin-bottom: 15px; }
  .ca-cta-body { font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 400; color: #FFFFFF; line-height: 160%; max-width: 442px; margin-bottom: 30px; }
  .ca-cta-btn { display: inline-block; background: #EB2019; color: #ffffff; font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 500; padding: 14px 36px; border-radius: 10px; text-decoration: none; border: none; cursor: pointer; transition: background 0.2s; line-height: 1; }
  .ca-cta-btn:hover { background: #c91a13; }

  /* RESPONSIVE TABLET */
  @media (max-width: 768px) {
    .ca-hero              { height: 350px; }
    .ca-hero-content      { padding: 0 32px; }
    .ca-hero-title        { font-size: 30px; margin-bottom: 16px; }
    .ca-hero-divider      { width: 200px; }
    .ca-hero-desc         { font-size: 14px; }
    .ca-breadcrumb        { padding: 28px 0 0 0; }
    .ca-breadcrumb-inner  { padding: 0 32px; }
    .ca-inner             { padding: 0 32px; }
    .ca-main-section      { padding: 48px 0 48px 0; }
    .ca-main-row          { gap: 32px; }
    .ca-left { flex: 0 0 350px;    padding-top: 0px; }
    .ca-heading           { font-size: 22px; }
    .ca-quote {  font-size: 14px;}
    .ca-body {  font-size: 14px;}
    .ca-social-row {     padding: 20px; gap: 44px;}
    .ca-social-icon { width: 40px; height: 40px;}
    
    .ca-right             { flex: 0 0 320px; }
    .ca-slider            { height: 240px; }
    .ca-cta-section       { min-height: 360px;  }
    .ca-cta-inner         { padding: 0 32px; }
    .ca-cta-title         { font-size: 26px; }
    .ca-cta-subtitle      { font-size: 14px; }
  }

  /* RESPONSIVE MOBILE */
  @media (max-width: 480px) {
    .ca-hero              { height: 400px; }
    .ca-hero-content      { padding: 0 16px; }
    .ca-hero-title        { font-size: 24px; margin-bottom: 15px; }
    .ca-hero-divider      { width: 180px; margin-bottom: 15px; max-width: 370px;  }
    .ca-hero-desc         { font-size: 16px; max-width: 370px; }
    .ca-breadcrumb        { padding: 32px 0 0 0; }
    .ca-breadcrumb-inner  { padding: 0 16px; gap: 14px; }
    .ca-bc-item           { font-size: 14px; }
    .ca-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .ca-inner             { padding: 0 16px; }
    .ca-main-section      { padding: 30px 0 60px 0; }
    .ca-main-row          { flex-direction: column; gap: 60px; }
    .ca-heading           { font-size: 24px; margin-bottom: 15px; }
    .ca-quote             { font-size: 16px;margin-bottom: 12px; }
    .ca-body              { font-size: 16px; margin-bottom: 30px; }
        .ca-social-row { max-width: 374px; gap: 49px;}
    .ca-right             { flex: none; width: 100%; }
    .ca-slider            { height: 220px; }
    .ca-social-icon       { width: 42px; height: 42px; }
    .ca-cta-section       { min-height: 400px; ; margin-bottom: 60px; }
    .ca-cta-inner         { padding: 48px 16px; }
    .ca-cta-title         { font-size: 24px; margin-bottom: 15px; }
    .ca-cta-subtitle      { font-size: 16px; }
    .ca-cta-body          { font-size: 16px; margin-bottom: 30px; }
    .ca-cta-btn           { font-size: 16px; padding: 14px 36px; }
  }
`;

/* Social icons — no links, display only */
const SOCIAL = [
  { img: IconReadImg,   label: "Read"   },
  { img: IconChartImg,  label: "Chart"  },
  { img: IconSportsImg, label: "Sports" },
  { img: IconSmileImg,  label: "Smile"  },
];

export default function Careers() {
  const [activeSlide, setActiveSlide] = React.useState(0);
  const intervalRef = React.useRef(null);
  const dragStartX = React.useRef(null);
  const isDragging = React.useRef(false);
  const DRAG_THRESHOLD = 50;

  const stopAutoplay = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  const startAutoplay = () => {
    stopAutoplay();
    intervalRef.current = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % SLIDES.length);
    }, 3500);
  };

  React.useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, []);

  const handleDotClick = (idx) => {
    stopAutoplay();
    setActiveSlide(idx);
    startAutoplay();
  };

  const handleDragStart = (clientX) => {
    dragStartX.current = clientX;
    isDragging.current = false;
    stopAutoplay();
  };

  const handleDragEnd = (clientX) => {
    if (dragStartX.current === null) return;
    const diff = dragStartX.current - clientX;
    if (Math.abs(diff) > DRAG_THRESHOLD) {
      isDragging.current = true;
      if (diff > 0) {
        setActiveSlide((prev) => (prev + 1) % SLIDES.length);
      } else {
        setActiveSlide((prev) => (prev - 1 + SLIDES.length) % SLIDES.length);
      }
    }
    dragStartX.current = null;
    startAutoplay();
  };

  return (
    <div className="ca">
      <style>{CSS}</style>

      {/* TOP RED BAR */}
      <div className="ca-top-bar" />

      {/* 1. HERO */}
      <section className="ca-hero">
        <img className="ca-hero-bg" src={HeroBgImg} alt="Careers at Ador" />
        <div className="ca-hero-overlay" />
        <div className="ca-hero-content">
          <h1 className="ca-hero-title">Careers</h1>
          <hr className="ca-hero-divider" />
          <p className="ca-hero-desc">
            Clean air and the use of sustainable and renewable energy are
            challenges facing countries around the world.
          </p>
        </div>
      </section>

      {/* 2. BREADCRUMB */}
      <nav className="ca-breadcrumb" aria-label="Breadcrumb">
        <div className="ca-breadcrumb-inner">
          <a href="/" className="ca-bc-item">Home</a>
          <span className="ca-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/about-us" className="ca-bc-item">About Us</a>
          <span className="ca-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ca-bc-item active">Careers</span>
        </div>
      </nav>

      {/* 3. MAIN CONTENT */}
      <section className="ca-main-section">
        <div className="ca-inner">
          <div className="ca-main-row">

            {/* Left */}
            <div className="ca-left">
              <h2 className="ca-heading">Do You Want To Help Change The World?</h2>
              <p className="ca-quote">
                "We are always in search of the next generation of creators,
                thinkers, innovators, dreamers and doers."
              </p>
              <p className="ca-body">
                To get a better sense of what it means to be an Adorian, tune in
                and watch our videos on the Ador channel and follow us on YouTube.
                Read our blog to keep up with the latest conversations, product
                developments and happenings in the Ador World. Explore some of
                our current opportunities on our LinkedIn page.
              </p>
              {/* Social icons — no links */}
              <div className="ca-social-row">
                {SOCIAL.map((s) => (
                  <span key={s.label} className="ca-social-icon" aria-label={s.label}>
                    <img src={s.img} alt={s.label} />
                  </span>
                ))}
              </div>
            </div>

            {/* Right — slider */}
            <div className="ca-right">
              <div
                className="ca-slider"
                onMouseDown={(e) => handleDragStart(e.clientX)}
                onMouseUp={(e) => handleDragEnd(e.clientX)}
                onMouseLeave={() => { dragStartX.current = null; startAutoplay(); }}
                onTouchStart={(e) => handleDragStart(e.touches[0].clientX)}
                onTouchEnd={(e) => handleDragEnd(e.changedTouches[0].clientX)}
              >
                {SLIDES.map((src, idx) => (
                  <img
                    key={idx}
                    className={`ca-slide${activeSlide === idx ? " active" : ""}`}
                    src={src}
                    alt={`Ador team ${idx + 1}`}
                  />
                ))}
                <div className="ca-ador-badge">
                  <div>
                    <div className="ca-ador-badge-name">ador</div>
                    <div className="ca-ador-badge-sub">peace of mind</div>
                  </div>
                </div>
              </div>
              <div className="ca-dots">
                {SLIDES.map((_, idx) => (
                  <button
                    key={idx}
                    className={`ca-dot${activeSlide === idx ? " active" : ""}`}
                    onClick={() => handleDotClick(idx)}
                    aria-label={`Slide ${idx + 1}`}
                  />
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 4. CTA */}
      <section className="ca-cta-section">
        <img className="ca-cta-bg" src={CtaBgImg} alt="" />
        <div className="ca-cta-overlay" />
        <div className="ca-cta-inner">
          <h2 className="ca-cta-title">Schedule a Meeting</h2>
          <p className="ca-cta-subtitle">Your Peace Of Mind Puts Our Mind At Peace.</p>
          <p className="ca-cta-body">
            Ador Is Here To Help You And Answer Your Questions
            About Our Products, Solutions And Services.
          </p>
          <a href="/contact-us" className="ca-cta-btn">Request a Schedule</a>
        </div>
      </section>

    </div>
  );
}